import { render, staticRenderFns } from "./NotRFSLocations.vue?vue&type=template&id=c4d4802c&"
import script from "./NotRFSLocations.vue?vue&type=script&lang=js&"
export * from "./NotRFSLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports